import { render, staticRenderFns } from "./DynamicPage.vue?vue&type=template&id=2100c887&scoped=true"
import script from "./DynamicPage.vue?vue&type=script&lang=js"
export * from "./DynamicPage.vue?vue&type=script&lang=js"
import style0 from "./DynamicPage.vue?vue&type=style&index=0&id=2100c887&prod&scoped=true&lang=css"
import style1 from "./DynamicPage.vue?vue&type=style&index=1&id=2100c887&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2100c887",
  null
  
)

export default component.exports